import { types } from "../types/types";
const intitalState = {
    allStaticPages: [],
};

const staticPageReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.STATIC_PAGES:
            return {
                ...state,
                allStaticPages: action.payload,
            };
        default:
            return { ...state };
    }
};

export default staticPageReducer;
